module.exports = __webpack_public_path__ + "media/images/flags/32/Saudi-Arabia-a52f88f7078887b7bbafb4b52127f9e0.png";